module.exports = __webpack_public_path__ + "img/jameson-1-text.0aa8ebfc.png";